import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
const subs = new Set();

export const reloadLookups = () => {
  cache = api.get("/lookups?active=true").then((r) => r.data).catch(() => []);
  cache.then((rows) => subs.forEach((f) => f(rows)));
  return cache;
};

// Active supporting-list values (Other masters → Supporting lists), shared across the app.
export function useLookups() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    subs.add(setRows);
    (cache || reloadLookups()).then(setRows);
    return () => { subs.delete(setRows); };
  }, []);
  const of = (t) => rows.filter((r) => r.type === t);
  return { rows, of, opts: (t) => of(t).map((r) => r.value) };
}

// Expense heads (code + label) plus any legacy codes already on a record.
export function useHeads(extra = []) {
  const { of } = useLookups();
  const heads = of("expense_type").map((h) => ({ code: h.code, label: h.value }));
  extra.filter((c) => c && !heads.some((h) => h.code === c)).forEach((c) => heads.push({ code: c, label: c }));
  return heads;
}
